<div class="dialog-form">
    <div class="flex-row">
        <iframe [src]="path" frameborder="0" width="100%" height="900"> </iframe>
    </div>
</div>